mutation RestoreSmsCampaign($input: SmsCampaignRestoreInput!) {
    smsCampaignRestore(input: $input) {
        campaign {
            id
        }
    }
}
